<template>
  <div class="root" v-if="canUse">
    <!--alert显示-->
    <alert-dialog
      v-if="showAlert"
      @close-dialog="showAlert = false"
      :action-block="actionBlock"
      :cancel-block="cancelBlock"
      :dialog-type="dialogType"
      :alert-msg="alertMsg"
    >
    </alert-dialog>
    <nlp></nlp>
    <router-view></router-view>
  </div>
</template>

<script type="text/babel">
import store from "./vuex/store";
import AlertDialog from "./components/common/dialog/AlertDialog.vue";
import MessageBox from "./components/common/dialog/MessageBox.vue";
import Nlp from './components/nlp/index.vue'
import VuexMixin from "mixins/vuex";

export default {
  store,
  mixins: [VuexMixin],
  vuex: {
    actions: {
      setScreenInfo: ({ dispatch }, w, h) => dispatch("SET_SCREEN_INFO", w, h),
    },
    getter: {
      pageWidth: (state) => state.page.width,
    },
  },

  components: {
    AlertDialog,
    MessageBox,
    Nlp
  },

  data() {
    return {
      showAlert: false,
      showMessage: false,
      messageBoxMsg: "",
      alertMsg: "",
      dialogType: 1, // 1是1个按钮  2是两个按钮
      actionBlock: null,
      cancelBlock: null,
    };
  },

  created() {
    this.$nextTick(() => {
      // console.log();

      this.setScreenInfo($(window).width(), $(window).height());
    });
    window.addEventListener("resize", () => {
      const width = $(window).width();
      // this.setScreenInfo(
      //   width > this.pageWidth ? width : this.pageWidth,
      //   $(window).height()
      // );
    });
  },

  computed: {
    showEditorHeader() {
      const route_name = this.$route.name;
      const array = ["apps", "register", "login"];
      return array.indexOf(route_name) == -1;
    },
    // editor.wudaima.com 禁止直接访问
    // 20191107 停止禁用
    canUse() {
      // const hostname = 'editor.wudaima.com';
      // // const hostname = 'editor.hexdo.com';
      // if (location.hostname === hostname) {
      //   // 缩略版 页面编辑页面弹框可以显示
      //   const allowedRoutes = ['panel', 'flow'];
      //   if (allowedRoutes.indexOf(this.$route.name) !== -1 && this.$route.query.mode == 1) {
      //     return true;
      //   }
      //   if (window.self == window.top) {
      //     return false;
      //   }
      // }
      return true;
    },
  },

  methods: {
    mousedown(e) {
      if (e.button == 2) {
        // console.log("你点了右键");
      } else if (e.button == 0) {
        // console.log("你点了左键");
      } else if (e.button == 1) {
        // console.log("你点了滚轮");
      }
    },
  },

  events: {
    showDialogAction(dialogType, msg, actionBlock, cancelBlock) {
      this.showAlert = true;
      this.alertMsg = msg;
      this.dialogType = dialogType;
      this.actionBlock = actionBlock;
      this.cancelBlock = cancelBlock;
    },
    showMessageBoxAction(msg) {
      this.showMessage = true;
      this.messageBoxMsg = msg;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
@import "assets/less/mixin";
.root {
  height: 100%;
}
body::-webkit-scrollbar {display:none;}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  border-radius: 1em;
  background-color: rgba(50, 50, 50, 0.3);
}
::-webkit-scrollbar-track {
  border-radius: 1em;
  background-color: rgba(50, 50, 50, 0.1);
}
body {
  font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh,
    HelveticaNeueW10-45Ligh, sans-serif;
}

.modal-body h2 {
  color: #575757;
  font-size: 20px;
  text-align: center;
  font-weight: 500;
  margin: 25px 0 30px 0;
  padding: 0;
  line-height: 40px;
}

.logo-font {
  font-weight: 100;
  margin: 0;
  letter-spacing: -1px;
}

.btn {
  cursor: pointer;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}

/**
 * Correct `inline-block` display not defined in IE 8/9.
 *
 * 修正在 IE 8/9 中未定义的 'inline-block' 元素。
 */

audio,
canvas,
video {
  display: inline-block;
}
.ivu-message {
  width: auto;
  vertical-align: middle;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.ivu-message .ivu-message-notice {
  position: relative;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// App.vue?fad2cf3c